import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { ActivityPointListItem } from './vehicle-trip-info/activity-point-list-item';

@Injectable()
export class VehicleService {
    activityPointListItem = new BehaviorSubject<ActivityPointListItem[]>(undefined);

}
